import { OptionProps } from "./utils.type";

export const findOptionByValue = (
  options: OptionProps[],
  value: string
): OptionProps | null => {
  return options.find((option) => option.value === value) || null;
};
